import React from 'react';

const FeatureCard = ({ icon, title, description }) => {
  return (
    <div className="bg-white dark:bg-slate-800 p-6 rounded-2xl shadow-lg hover:shadow-glow border-t-4 border-primary dark:border-primary flex flex-col items-start hover:-translate-y-2 transition-all duration-300">
      <div className="flex items-center md:block gap-4 md:gap-0 w-full md:w-auto mb-3 md:mb-0">
        <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center md:mb-5 text-primary shrink-0">
          <i className={`${icon} text-2xl`}></i>
        </div>
        <h3 className="font-display font-bold text-xl text-slate-900 dark:text-white md:mb-3">
          {title}
        </h3>
      </div>
      <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed font-light">
        {description}
      </p>
    </div>
  );
};

export default FeatureCard;
